<template>
  <v-container>
    <v-navigation-drawer
      app
      fixed
      left
      permanent
      clipped
      dark
      class="navigation-drawer elevation-2"
    >
      <template v-slot:prepend>
        <v-img src="@/assets/itmo_small_blue_logo.png"></v-img>
        <v-divider></v-divider>
      </template>
      <list-of-topics></list-of-topics>
    </v-navigation-drawer>
    <router-view></router-view>
  </v-container>
</template>

<script>
import ListOfTopics from '../components/learn/lists/ListOfTopics'
export default {
  name: 'Learn',
  components: {
    ListOfTopics
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/colors";
.navigation-drawer {
  background-color: white!important;
}
</style>
